import React from 'react'
import CheckShield from '../icons/check-shield/index'

function FeatureShield({ title, description, check_shield }) {
  return (
    <>
      <div className='feature'>
        <div className='feature-title-container'>
          <CheckShield color={check_shield} />
          <span className='feature-title'>{title}</span>
        </div>
        <div className='feature-desc'>
          <span>{description}</span>
        </div>
      </div>
      <style jsx>{`
        .feature {
          min-width: 30rem;
          flex: 0 1 10%;
          flex-wrap: wrap;
        }
        .feature-title-container {
          line-height: 32px;
          margin-top: -4px;
          text-align: left;
          font-family: Red Hat Display;
          font-style: normal;
          font-weight: bold;
          font-size: 24px;
          color: rgba(21, 42, 70, 1);
          margin-left: 1rem;
          white-space: nowrap;
          display: flex;
          align-items: center;
        }
        .feature-title {
          margin-left: 1rem;
        }
        .feature-desc {
          text-align: left;
          font-family: Red Hat Display;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: rgba(21, 42, 70, 1);
          margin: 0.5rem 2rem 4rem 4rem;
        }
        @media (max-width: 1200px) {
          .feature-title {
            font-size: 18px;
          }
          .feature-desc {
            font-size: 16px;
          }
        }
      `}</style>
    </>
  )
}

export default FeatureShield
